export default __webpack_public_path__ + "static/media/mockup-boola.a568c732.png";